import { render, staticRenderFns } from "./MenuTile.vue?vue&type=template&id=5ab04af2&scoped=true&"
import script from "./MenuTile.vue?vue&type=script&lang=js&"
export * from "./MenuTile.vue?vue&type=script&lang=js&"
import style0 from "./MenuTile.vue?vue&type=style&index=0&id=5ab04af2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab04af2",
  null
  
)

export default component.exports